/**
 * AbilityAddLine.js
 * Implements the AddRandomLine enemy ability
 */

import { Ability } from "./Ability";
import { Common } from "../Common";

import { ENEMY_ABILITY_PARTICLE_ADD_LINE_TARGET_X } from "../../Constants";

export class AbilityAddLine extends Ability {
    /**
     * @public
     * @param {Number} nbLinesToAdd
     * @param {{x: Number, y: Number}} startPos
     * @param {Function} callback
     */
    constructor(nbLinesToAdd, startPos, callback) {
        super();

        /** @private @type {Number} */
        this._nbLinesToAdd = nbLinesToAdd;

        /** @private @type {Function} */
        this._callback = callback;

        // Ability particle targeting the right edge of the grid
        Common.particles.createEnemyAbilityParticle(
            startPos.x,
            startPos.y,
            ENEMY_ABILITY_PARTICLE_ADD_LINE_TARGET_X,
            0,
            this._onAbilityParticleCompleted.bind(this)
        );
    }

    /**
     * @private
     */
    _onAbilityParticleCompleted() {
        for (let i = 0; i < this._nbLinesToAdd; ++i) {
            Common.bubbleFactory.createLine();
        }

        if (this._callback) {
            this._callback();
        }
    }

    /**
     * @public
     */
    destroy() {
        this._callback = null;
    }
}
